import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedDataService {
  private _state$: BehaviorSubject<any> = new BehaviorSubject({});
  state$: Observable<any>;

  constructor() {
    this.state$ = this._state$.asObservable();
  }

  get state() {
    return this._state$.getValue();
  }

  asObservable() {
    return this.state$;
  }

  setItem(key, value): void {
    let values = this._state$.getValue();
    values[key] = value;

    this._state$.next(values);
  }

  getItem(key) {
    return this._state$.getValue()[key];
  }
}